import React, { useMemo, useState } from 'react';
import * as styles from './PostModalViewTopicBar.module.scss';
import type { DocumentType } from '../../graphql/generated';
import { gql } from '../../graphql/generated';
import { useAllTopicMap } from '../../topic/useAllTopics';
import populateObjects from '../../utils/populateObjects';
import sortTopicsByName from '../../utils/sortTopicsByName';
import PostSeriesInTopicList from '../series/PostSeriesInTopicList';
import PostTopicWithBreadcrumbs from '../topic/PostTopicWithBreadcrumbs';

const POST_FRAGMENT = gql(`
  fragment PostModalViewTopicBar_post on Post {
    id
    topics {
      id
    }
    series {
      id
      ...PostSeriesInTopicList_series
    }
  }
`);

interface PostModalViewTopicBarProps {
  post: DocumentType<typeof POST_FRAGMENT>;
}

const PostModalViewTopicBar = ({ post }: PostModalViewTopicBarProps) => {
  const [topicContainerEl, setTopicContainerEl] =
    useState<HTMLUListElement | null>(null);

  const allTopicMap = useAllTopicMap();
  const postTopics = populateObjects(
    allTopicMap,
    post.topics.map(({ id }) => id),
  );

  const itemsCount = postTopics.length + (post.series ? 1 : 0);

  const sortedTopics = useMemo(
    () => sortTopicsByName(postTopics),
    [postTopics],
  );

  return (
    <div className={styles.container}>
      <ul
        ref={setTopicContainerEl}
        className={styles.topicContainer}
        aria-label="Post topics"
      >
        {post.series && (
          <PostSeriesInTopicList
            postId={post.id}
            series={post.series}
            size="small"
            disableHoverView
          />
        )}
        {sortedTopics.map((topic) => (
          <PostTopicWithBreadcrumbs
            key={topic.id}
            topic={topic}
            containerEl={topicContainerEl}
            itemsPerRow={Math.min(itemsCount, 3) as 1 | 2 | 3}
            disableHoverView
            size="small"
          />
        ))}
      </ul>
    </div>
  );
};

export default PostModalViewTopicBar;
